import InfoTileContainer from "src/shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "src/shared-elements/info-tile/info-tile.component";
import MapDetail from "../../map-detail.component";

interface DashboardDetailMapWithBlockInfoProps {
  blockDetail: [];
  blockDetailData: [];
  isLoadingBlockDetails: boolean;
  isRefreshedLocationBlock: boolean;
}

const DashboardDetailMapWithBlockInfo: React.FC<
  DashboardDetailMapWithBlockInfoProps
> = ({
  blockDetail,
  isLoadingBlockDetails,
  isRefreshedLocationBlock,
  blockDetailData,
}) => {
  return (
    <div className="w-lg-63">
      <MapDetail
        blockDetail={blockDetail}
        isLoadingBlockDetails={
          isLoadingBlockDetails || isRefreshedLocationBlock
        }
      />

      <div className="mt-3" style={{ height: "13.3rem" }}>
        <InfoTileContainer header="Block Details">
          {blockDetailData.map((data: any) => (
            <InfoTileComponent
              key={data?.title}
              title={data?.title}
              value={data?.content}
              isLoading={isLoadingBlockDetails || isRefreshedLocationBlock}
            />
          ))}
        </InfoTileContainer>
      </div>
    </div>
  );
};

export default DashboardDetailMapWithBlockInfo;
